import component from "./tuevs/component";
import exams from "./tuevs/exams";
import material from "./tuevs/material";
import complement from "./tuevs/complement";
import method from "./tuevs/method";
import scale from "./tuevs/scale";
import time from "./tuevs/time";
import examresult from "./tuevs/examresult";

export default {
    component,
    exams,
    material,
    complement,
    method,
    scale,
    time,
    examresult
}
